<template>
  <nav class="main-navigation">
    <div class="navigation-wrapper">
      <logo width="6.5rem" />
      <section class="navigation-links">

      </section>
      <div class="navigation-end">
        <icon 
          icon="bell"
        />
        <dropdown-wrapper position="top-end">
          <avatar
            slot="trigger"
            slot-scope="{ isActive }"
            colorize
            presence="online"
            class="cursor-pointer"
            :name="user.name"
            :size="38"
            :path="user.profile_picture_url"
            :class="isActive ? 'chevron-down' : 'chevron-up'"
          />

          <dropdown-item @click="goToAccount">
            <icon class="mr" icon="cog" />
            <span>Account</span>
          </dropdown-item>

          <dropdown-item @click="signOut">
            <icon class="mr" icon="sign-out-alt" />
            <span>Sign Out</span>
          </dropdown-item>
        </dropdown-wrapper>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  computed: {
    ...mapGetters('auth', ['user']),
  },

  methods: {
    goToAccount() {
      this.$router.push({ name: 'account' })
    },

    signOut() {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'signin' })
      }).catch(error => {
        this.$router.push({ name: 'signin' })
      })
      
    },
  }

}
</script>
